import { useMemo } from 'react';

import {
  AccountBalance,
  GetAccountBalancesRequest,
  useGetAccountBalances,
} from 'entities/cex-account';
import { normalizeNumber } from 'utils/formats/normalizeNumber';
import { trimDecimalZeroes } from 'utils/formats/trimDecimalZeroes';

export const useCexAccountBalances = (req: GetAccountBalancesRequest) => {
  const { data } = useGetAccountBalances(req, {
    select: data =>
      (data.data?.accounts ?? []).reduce(
        (acc, val) => {
          acc[val.account_id] = {
            ...val,
            maker_fee: trimDecimalZeroes(normalizeNumber(Number(val.maker_fee) * 100)),
            taker_fee: trimDecimalZeroes(normalizeNumber(Number(val.taker_fee) * 100)),
          };

          return acc;
        },
        {} as Record<number, AccountBalance>,
      ),
  });
  const accountBalances = useMemo(() => data ?? {}, [data]);

  return { accountBalances };
};
